window.TestimonialsSliderModule = (() => {
  function initalizeTestimonialsSlider() {
    new Glide(".glide-" + "testimonials", {
      type: "slider",
      animationTimingFunc: "linear",
      perView: 1,
      breakpoints: {
        750: {
          perView: 1.4,
        },
      },
    })
      .mount()
      .play();
  }

  function assignSliderheight() {
    const sliders = document.querySelectorAll(".testimonials_wrapper");
    let biggestHeight = 0;
    sliders.forEach((slider) => {
      const height = slider.clientHeight;
      if (height > biggestHeight) {
        biggestHeight = height;
      }
    });
    sliders.forEach((slider) => {
      slider.style.height = biggestHeight + "px";
    });
  }

  window.onload = assignSliderheight;

  return {
    init: initalizeTestimonialsSlider,
  };
})();

document.addEventListener("DOMContentLoaded", function () {
  window.TestimonialsSliderModule.init();
});
